
import { defineComponent, onMounted, ref, inject } from 'vue';

import Carousel from '@/components/Carousel/index.vue';
import ServiceListItem from '@/components/ServiceListItem/index.vue';
import ShopImage from '@/components/ShopImage/index.vue';
import { useNavigate } from '@/composable';
import axios from 'axios';

interface carouselType {
  url: string;
  type: {
    name: 'local' | 'link' | 'navigate';
    link: string;
  };
}

interface serviceType {
  title: string;
  icon: string;
  titleTarget: string;
  describes: string[];
  url: string;
  img: string;
}

interface typeNewsList {
  category: any;
  id: number;
  postDate: string;
  summary: string;
  thumbnail: string;
  title: string;
}

export default defineComponent({
  name: 'DashBoard',
  components: { Carousel, ServiceListItem, ShopImage },
  setup() {
    const { navigate } = useNavigate();

    const isMobile = inject('isMobile');

    const isLoading = ref<boolean>(false);

    const refOurPolicy = ref<HTMLDivElement | null>(null);

    const carouselImages = ref<carouselType[]>([
      {
        url: require('@/assets/img/SlideBanner/image01.jpg'),
        type: {
          name: 'local',
          link: 'refOurPolicy'
        }
      },
      {
        url: require('@/assets/img/SlideBanner/image02.jpg'),
        type: {
          name: 'link',
          link: 'https://www.matsuzakihousing.jp'
        }
      },
      {
        url: require('@/assets/img/SlideBanner/image03.jpg'),
        type: {
          name: 'navigate',
          link: '/owner'
        }
      },
      {
        url: require('@/assets/img/SlideBanner/image04.jpg'),
        type: {
          name: 'navigate',
          link: '/asset-management'
        }
      }
    ]);

    const refServiceImgRight = ref<HTMLDivElement | null>(null);

    const serviceListItem = ref<serviceType[]>([
      {
        title: '不動産オーナーさま',
        icon: '',
        titleTarget: '01.',
        describes: [
          '中野・新井薬師の賃貸経営の「困った！」を丸ごと',
          'サポートいたします。'
        ],
        url: '/owner',
        img: require('@/assets/img/dashboard/service/background-service.png')
      },
      {
        title: 'お部屋を借りたい方',
        icon: '',
        titleTarget: '02.',
        describes: [
          '中野・新井薬師の賃貸ならお任せください！',
          '幸せになれる物件がきっと見つかります。'
        ],
        url: '/rent',
        img: require('@/assets/img/dashboard/service/background-service2.png')
      },
      {
        title: '不動産売買',
        icon: '',
        titleTarget: '03.',
        describes: [
          '中野・新井薬師の住宅・事業用不動産の購入、売却を',
          'お手伝いします。'
        ],
        url: '/buy',
        img: require('@/assets/img/dashboard/service/background-service3.png')
      }
    ]);

    const listData = ref<typeNewsList[]>([]);

    const listOfStores = [
      {
        linkImage: require('@/assets/img/CompanyProfile/honten.png'),
        titleButton: '本店',
        url: '0'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/araiyakushi.png'),
        titleButton: '新井薬師店',
        url: '1'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/image.png'),
        titleButton: '薬師北口店',
        url: '2'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/nakanokitaguchi.png'),
        titleButton: '中野北口店',
        url: '3'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/nakanominamiguchi.png'),
        titleButton: '中野南口店',
        url: '4'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/nakanonumabukuro.png'),
        titleButton: '中野沼袋店',
        url: '5'
      },
      {
        linkImage: require('@/assets/img/CompanyProfile/shinnakano.png'),
        titleButton: '新中野店',
        url: '6'
      }
    ];

    const getNumberPixel = (numberString: string) => {
      return +numberString.split('px')[0];
    };

    const onClickCarouselImg = (img: carouselType) => {
      switch (img.type.name) {
        case 'local':
          if (img.type.link === 'refOurPolicy') {
            const div = refOurPolicy.value as HTMLDivElement;
            // @ts-ignore
            const style = div?.currentStyle || window.getComputedStyle(div);

            const pixel =
              getNumberPixel(style.marginTop) +
              getNumberPixel(style.paddingTop);
            window.scroll({
              top: div?.offsetTop - pixel + 20,
              behavior: 'smooth'
            });
          }
          break;
        case 'navigate':
          navigate(img.type.link);
          break;
        default:
          window.open(img.type.link);
          break;
      }
    };

    const onHoverService = (item: serviceType) => {
      // @ts-ignore
      if (!isMobile.value) {
        // @ts-ignore
        refServiceImgRight.value!.src = item.img;
      }
    };

    const onLeaveService = () => {
      // @ts-ignore
      if (!isMobile.value) {
        // @ts-ignore
        refServiceImgRight!.value!.src = serviceListItem.value[0].img;
      }
    };

    const getDataNewsList = () => {
      isLoading.value = true;
      axios
        .get(
          'https://www.matuzaki.co.jp/wp/wp-json/custom/v0/news?limit=3&page=1'
        )
        .then((response: any) => {
          listData.value = response.data.news;
          isLoading.value = false;
        })
        .catch(() => {
          isLoading.value = false;
        });
    };

    const getDetailNew = (value: number) => {
      navigate('/news/detail', 'router', { id: value });
    };

    onMounted(() => {
      getDataNewsList();
      onLeaveService();
    });

    return {
      refOurPolicy,
      carouselImages,
      refServiceImgRight,
      serviceListItem,
      listOfStores,
      listData,
      navigate,
      onClickCarouselImg,
      onHoverService,
      onLeaveService,
      isLoading,
      getDetailNew,
      isMobile
    };
  }
});
